/** @format */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "fusion-plugin-react-router";
import Navbar from "../shared/components/navbar";
import Footer from "../shared/components/footer";
import PageContent from "../shared/components/PageContent";
import QuoteStep from "../features/quote/enums/QuoteStep";
import {
  fetchNewQuote,
  fetchPolicyDetails,
} from "../features/quote/services/quoteService";
import UberDetailsConfirmationModal from "../features/quote/components/uberDetailsConfirmationModal";
import useAppStateStore from "../shared/store/AppStateStore";
import AllQuoteSteps from "../features/quote/allQuoteSteps";
import AllBuySteps from "../features/buy/allBuySteps";
import useQuoteStore from "../features/quote/store/QuoteStore";
import { HotjarEventNames } from "../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../shared/utils/trackHotjarEvent";
import { scrollToTop } from "../shared/utils/scrollUtils";
import { fetchAddonsDescriptions } from "../features/buy/services/buyService";
import { isLocalQuoteTestMode } from "../shared/utils/localQuoteTestMode";
import QuoteStepLoader from "../shared/components/QuoteStepLoader";

const TaxiJourney = () => {
  const STATE = useAppStateStore();
  const quote = useQuoteStore().quote;
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");
  const navigate = useNavigate();
  const localQuoteTestMode = isLocalQuoteTestMode();
  const currentStep = STATE.currentStep;
  const hasLoadedDriverAddress = Boolean(
    quote?.quote?.risk?.drivers?.[0]?.address?.postcode,
  );
  const shouldFetchNewQuote =
    !localQuoteTestMode &&
    currentStep === QuoteStep.TQ1 &&
    !STATE.quoteCall &&
    !hasLoadedDriverAddress;
  const [isConfirmationModal, setIsConfirmationModal] = useState(
    !shouldFetchNewQuote,
  );
  const [newQuoteLoading, setNewQuoteLoading] = useState(shouldFetchNewQuote);
  useEffect(() => {
    if (localQuoteTestMode && currentStep !== QuoteStep.TQ1) {
      STATE.setCurrentStep(QuoteStep.TQ1);
    }
  }, []);

  useEffect(() => {
    if (
      !localQuoteTestMode &&
      currentStep === QuoteStep.TQ1 &&
      !STATE.quoteCall
    ) {
      if (!hasLoadedDriverAddress) {
        const fetchData = async () => {
          setIsConfirmationModal(false);
          setNewQuoteLoading(true);
          try {
            await fetchNewQuote(code, navigate);
            await Promise.allSettled([
              fetchPolicyDetails(),
              fetchAddonsDescriptions(),
            ]);
          } catch (error) {
            console.error("Error fetching quote:", error);
          } finally {
            setNewQuoteLoading(false);
            setIsConfirmationModal(true);
          }
        };
        fetchData();
      }
    }
  }, [currentStep]);

  useEffect(() => {
    if (!code) {
      TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_START_LANDING);
    }
  }, [code]);

  // console.log(quote.risk);

  return (
    <>
      <div className="tw-flex tw-min-h-screen tw-flex-col tw-text-dis-base tw-leading-[1.5] tw-text-dis-text-2 [&_*]:tw-box-border">
        <Navbar />
        <PageContent>
          {newQuoteLoading ? (
            <QuoteStepLoader
              title="Preparing your quote"
              description="We’re retrieving your Uber details and getting your quote ready."
              message="Fetching your Uber details..."
            />
          ) : (
            <>
              <AllBuySteps />
              <AllQuoteSteps />
            </>
          )}
        </PageContent>
        <Footer />
      </div>

      {isConfirmationModal &&
        !localQuoteTestMode &&
        currentStep === QuoteStep.TQ1 &&
        !newQuoteLoading && (
          <UberDetailsConfirmationModal
            onClose={() => {
              setIsConfirmationModal(false);
              scrollToTop();
            }}
          />
        )}
    </>
  );
};

export default TaxiJourney;
